import { ChevronDown as ChevronDownIcon } from '@vgno/icons';
import { useTranslation } from 'react-i18next';

import * as styles from './CompanionAdHeader.module.scss';

function CompanionAdHeader() {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <ChevronDownIcon />
      <span className={styles.label}>{t('more videos under the ad')}</span>
      <ChevronDownIcon />
    </div>
  );
}

export { CompanionAdHeader };
